import displayAlert from './displayAlert';

const logic = [displayAlert];
export default logic;
